export const GET_ALL_LASTREADINGTAKEN_REQUEST = "GET_ALL_LASTREADINGTAKEN_REQUEST"
export const GET_ALL_LASTREADINGTAKEN_SUCCESS = "GET_ALL_LASTREADINGTAKENG_SUCCESS"
export const GET_ALL_LASTREADINGTAKEN_FAIL = "GET_ALL_LASTREADINGTAKEN_FAIL"
